import React from "react";
import { NavLink } from "react-router-dom";

import {
  canAccessCustomHedgeReport,
  canAccessHedgeLockReport,
  canAccessHedgePlanning,
  canAccessSettlementInsights,
  canAccessBuyerLocationInsights,
  canAccessTestingReports,
  canAccessBuyingInsights,
  canAccessAssayInsights,
  getLoginDetails,
} from "../../utils/storage";

export function InsightsSubNav() {
  const loginDetails = getLoginDetails();
  const showTestingReports = canAccessTestingReports(loginDetails);
  const showCustomHedge = canAccessCustomHedgeReport(loginDetails);
  const showHedgeLock = canAccessHedgeLockReport(loginDetails);
  const showAssayInsights = canAccessAssayInsights(loginDetails);
  const showHedgePlanning = canAccessHedgePlanning(loginDetails);
  const showSettlementInsights = canAccessSettlementInsights(loginDetails);
  const showBuyerLocation = canAccessBuyerLocationInsights(loginDetails);
  const showBuyingInsights = canAccessBuyingInsights(loginDetails);

  return (
    <div className="insights-subnav">
      <NavLink
        to="/insights"
        exact
        className="insights-subnav-tab"
        activeClassName="active"
      >
        Ounce
      </NavLink>
      {showHedgePlanning && (
        <NavLink
          to="/insights/hedge-planning"
          className="insights-subnav-tab"
          activeClassName="active"
        >
          Hedge Planning
        </NavLink>
      )}
      {showSettlementInsights && (
        <NavLink
          to="/insights/lot-hedge"
          className="insights-subnav-tab"
          activeClassName="active"
        >
          Lot Settlement
        </NavLink>
      )}
      {showSettlementInsights && (
        <NavLink
          to="/insights/cxo-settlement"
          className="insights-subnav-tab"
          activeClassName="active"
        >
          CXO Settlement
        </NavLink>
      )}
      {showSettlementInsights && (
        <NavLink
          to="/insights/underpayment-leak"
          className="insights-subnav-tab"
          activeClassName="active"
        >
          Underpayment Leak
        </NavLink>
      )}
      {showBuyingInsights && (
        <NavLink
          to="/insights/buying"
          className="insights-subnav-tab"
          activeClassName="active"
        >
          Buying
        </NavLink>
      )}
      {showBuyerLocation && (
        <NavLink
          to="/insights/location"
          className="insights-subnav-tab"
          activeClassName="active"
        >
          Location
        </NavLink>
      )}
      {showTestingReports && (
        <NavLink
          to="/insights/testing"
          className="insights-subnav-tab"
          activeClassName="active"
        >
          Testing Reports
        </NavLink>
      )}
      {showCustomHedge && (
        <NavLink
          to="/insights/custom-hedge"
          className="insights-subnav-tab"
          activeClassName="active"
        >
          Custom Hedge
        </NavLink>
      )}
      {showHedgeLock && (
        <NavLink
          to="/insights/hedge-lock"
          className="insights-subnav-tab"
          activeClassName="active"
        >
          Hedge Lock
        </NavLink>
      )}
      {showAssayInsights && (
        <NavLink
          to="/insights/assay"
          className="insights-subnav-tab"
          activeClassName="active"
        >
          Assay
        </NavLink>
      )}
    </div>
  );
}
